function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "27DD9921-0ECD-402C-B017-C3CAFA3C5262");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Pagina_principal",
  transform: "translate(-422.000000, -175.000000)",
  stroke: "#061F79",
  strokeWidth: 1.5
}, React.createElement("polyline", {
  id: "arrow",
  points: "423 176.094902 428.396161 181.852998 434 176.094902"
})));

var SvgMmArrow = function SvgMmArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "13px",
    height: "8px",
    viewBox: "0 0 13 8",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMmArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mm-arrow.161a2407.svg";
export { ForwardRef as ReactComponent };